// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.interview-container {
    padding: 20px;
    max-width: 600px;
    margin: 0 auto;
    font-family: 'Inter', sans-serif;
  }
  
  .interview-container h2 {
    font-size: 1.5rem;
    color: #0047AB;
  }
  
  .interview-container form {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  .interview-container label {
    font-size: 1rem;
    color: #333;
  }
  
  .interview-container input {
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
  }
  
  .interview-container button {
    padding: 10px 20px;
    background-color: #0047AB;
    color: #ffffff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .interview-container button:hover {
    background-color: #003080;
  }
  
  .interview-container p {
    font-size: 1rem;
    color: #333;
  }

.transcript {
  margin-top: 20px;
}

.transcript-entry {
  margin: 10px 0;
  padding: 10px;
  border-radius: 5px;
}

.transcript-entry.interviewer {
  background-color: #e0f7fa;
  text-align: left;
  margin-left: 10px;
}

.transcript-entry.user {
  background-color: #f1f8e9;
  text-align: right;
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/Interview.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,gCAAgC;EAClC;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;AAEF;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":[".interview-container {\n    padding: 20px;\n    max-width: 600px;\n    margin: 0 auto;\n    font-family: 'Inter', sans-serif;\n  }\n  \n  .interview-container h2 {\n    font-size: 1.5rem;\n    color: #0047AB;\n  }\n  \n  .interview-container form {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .interview-container label {\n    font-size: 1rem;\n    color: #333;\n  }\n  \n  .interview-container input {\n    padding: 8px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n  }\n  \n  .interview-container button {\n    padding: 10px 20px;\n    background-color: #0047AB;\n    color: #ffffff;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n  \n  .interview-container button:hover {\n    background-color: #003080;\n  }\n  \n  .interview-container p {\n    font-size: 1rem;\n    color: #333;\n  }\n\n.transcript {\n  margin-top: 20px;\n}\n\n.transcript-entry {\n  margin: 10px 0;\n  padding: 10px;\n  border-radius: 5px;\n}\n\n.transcript-entry.interviewer {\n  background-color: #e0f7fa;\n  text-align: left;\n  margin-left: 10px;\n}\n\n.transcript-entry.user {\n  background-color: #f1f8e9;\n  text-align: right;\n  margin-right: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
